export default __webpack_public_path__ + "static/media/330_dummy2016-schneiderei01-mobile-de.b456dfd1.png";